var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4802 10.4126C16.0902 10.8026 15.4402 10.8026 15.0502 10.4126L10.5802 5.95265L3.53018 12.9926L2.87018 12.3626C1.70018 11.1926 1.70018 9.29265 2.87018 8.12265L7.11018 3.88265C8.28018 2.71265 10.1802 2.71265 11.3502 3.88265L16.4802 9.00265C16.8702 9.39265 16.8702 10.0226 16.4802 10.4126ZM17.1802 8.29265C17.9602 9.07265 17.9602 10.3426 17.1802 11.1226C15.9102 12.3926 14.5702 11.3426 14.3502 11.1226L10.5902 7.36265L5.02018 12.9326C4.63018 13.3226 4.63018 13.9526 5.02018 14.3426C5.41018 14.7326 6.04018 14.7326 6.44018 14.3426L11.0602 9.72265L11.7702 10.4326L7.15018 15.0526C6.76018 15.4426 6.76018 16.0726 7.15018 16.4626C7.54018 16.8526 8.17018 16.8526 8.57018 16.4626L13.1902 11.8426L13.9002 12.5526L9.28018 17.1726C8.89018 17.5626 8.89018 18.1926 9.28018 18.5826C9.67018 18.9726 10.3002 18.9726 10.6902 18.5826L15.3102 13.9626L16.0202 14.6726L11.4002 19.2926C11.0102 19.6826 11.0102 20.3126 11.4002 20.7026C11.7902 21.0926 12.4202 21.0926 12.8102 20.7026L21.1302 12.3626C22.3002 11.1926 22.3002 9.29265 21.1302 8.12265L16.8902 3.88265C15.7402 2.73265 13.8802 2.71265 12.7102 3.82265L17.1802 8.29265Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshakeIcon);
export default __webpack_public_path__ + "static/media/handshake_icon.ac28f7f2.svg";
export { ForwardRef as ReactComponent };